export function calcBounds(positionedObjects) {
    let north;
    let south;
    let west;
    let east;
    for (const { position } of positionedObjects) {
        if (north === undefined || north < position.lat)
            north = position.lat;
        if (south === undefined || south > position.lat)
            south = position.lat;
        if (west === undefined || west > position.lon)
            west = position.lon;
        if (east === undefined || east < position.lon)
            east = position.lon;
    }
    return [west, south, east, north];
}
export async function awaitTime(miliseconds) {
    return new Promise(resolve => setTimeout(resolve, miliseconds));
}
export function once(builder) {
    let isCalled = false;
    let value;
    return () => {
        if (!isCalled) {
            isCalled = true;
            value = builder();
        }
        return value;
    };
}
export function formatTime(seconds) {
    let s = seconds;
    const h = Math.floor(s / 3600);
    s %= 3600;
    let m = Math.floor(s / 60);
    s %= 60;
    if (m < 10)
        m = `0${m}`;
    if (s < 10)
        s = `0${s}`;
    return `${h}:${m}:${s}`;
}
